<template>
  <div class="typeInfo">
    <main-title :title="title">
      <!-- <div slot="top" class="city-area" @click="handleClick('city')">
        <div class="choose-city">
          <i></i>
          <label v-if="_area.text">{{_area.text}}</label>
          <label v-else class="select-txt">{{$t('city.selectTxt')}}</label>
        </div>
      </div>-->
    </main-title>
    <div v-if="showTypeInfo" style="position:relative;padding-bottom:2.5rem">
      <div class="typeInfoContent">
        <type-card
          :key="idx"
          v-for="(item,idx) in typeCardArr"
          :title="item.title"
          :desc="item.desc"
          :type-id="item.key"
          :index="item.key"
          :is-checked="identity === item.key"
          @choose="handleClick"
        ></type-card>
      </div>
      <div class="btn-wraper">
        <!-- <p class="text-link">
          <span @click="showSite">{{offline_offsite.title}}</span>
        </p>-->
        <input
          type="button"
          :value="$t('typeInfo.next_btn_desc')"
          :class="{'active':isCanSubmit}"
          :disabled="!isCanSubmit"
          @click="handleClick('submit')"
        />
      </div>
    </div>

    <div v-if="!showTypeInfo">
      <ul>
        <li class="otherCityTxt" v-for="(item,idx) in otherCityTextList" :key="idx" v-html="item"></li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { post } from "../../tools/request";
import { showDialog } from "../../tools/Tip";
import { SERVICE_PHONE, SUPPORT_COUNTRY } from "../../tools/constant";

import MainTitle from "../base/main-title";
import TypeCard from "../base/type-card";
import OfflineSite from "../base/offline-site";
import { ends } from '../../tools/constant';

const OTHER_CITY_ID = 12345678;

export default {
  mounted() {
    this.initData();
    this.ab_text();
    Omega.trackEvent("gd_driverRole_view_sw");
  },
  data() {
    return {
      areaId: "",
      // areaName: "",
      identity: "",
      identityInfo: {
        3: {
          key: "3",
          title: this.$t("drivingPartner"),
          desc: this.$t("typeInfo.drivingPartner_desc")
        },
        1: {
          key: "1",
          title: this.$t("driver"),
          desc: this.$t("typeInfo.driver_desc")
        },
        13: {
          key: "13",
          title: this.$t("GDriver_fleet_I_have_MLZw"),
          desc: this.$t("GDriver_fleet_I_want_xBbL").replace(/{{brand_name}}/, this.$t("GDriver_Name_99_mpNh"))
        },
        2: {
          key: "2",
          title: this.$t("nonDrivingPartner"),
          desc: this.$t("typeInfo.nonDrivingPartner_desc"),
        },
      },
      showTypeInfo: true,
      title: this.$t("typeInfo.title")
    };
  },
  computed: {
    ...mapState([
      "_ticket",
      "_area",
      "_identity",
      "_product",
      "_br_new_text",
      "_uuid",
      "_br_type_product_text"
    ]),
    location_country() {
      return new URLSearchParams(location.search).get("location_country");
    },
    typeCardArr() {
      let i = this.identityInfo;
      // if (this._product == 2) {
      //@20190904 巴西产品线目前只会存在于URL
      // if (new URLSearchParams(location.search).get("product") == 2) {
      //   return [i[3], i[1]];
      // }
      let up = new URLSearchParams(location.search);
      //@20191024 业务调整
      let p = up.get("product") || this._product;
      if (p == 2) {
        // @20220316 http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=799431263&preview=/https%3A%2F%2Fcooper.didichuxing.com%2Fcooper_gateway%2Fcn%2Fshimo-images%2FPUkmuEq5wf02yQGQ%2Fimage.png
        if (this.location_country === 'BR' && ends.isFleetApp) {
          return [i[13], i[2]];
        } else if (up.get('hasBrFleetReg') === '1') {
          return [i[3], i[1], i[13], i[2]];
        } else {
          return [i[3], i[1]];
        }
      }
      //出租车业务线，只保留车主选择
      return [i[3]];
    },
    isCanSubmit() {
      // return !!(this.areaId && this.identity);
      return !!this.identity;
    },
    otherCityTextList() {
      const arr = [
        this.$t("typeInfo.other_city_txt1"),
        this.$t("typeInfo.other_city_txt2")
      ];
      let TEL = SERVICE_PHONE[this.location_country] || "";
      return arr.map(item => {
        return item.replace(
          /\{tel\}/,
          `<a href=tel:${TEL} style="color:#FF7226">${TEL}</a>`
        );
      });
    }
  },
  methods: {
    ...mapMutations(["setState"]),
    showSite() {
      this.$refs.offlineSite.getLineSite();
      this.$refs.offlineSite.show();
    },
    ab_text() {
      if (this._br_new_text) {
        this.title = "Como você prefere dirigir?";
        this.identityInfo[3].title = "Carro próprio";
        this.identityInfo[3].desc = "Gostaria de utilizar meu carro particular";
        this.identityInfo[1].title = "Carro alugado";
        this.identityInfo[1].desc = "Gostaria de alugar um carro";
      }
      if (this._br_type_product_text) {
        this.title = "Escolha como prefere dirgir";
        this.identityInfo[3].title = "Tenho carro próprio";
        this.identityInfo[3].desc = "Quero ser parceiro 99 e tenho carro";
        this.identityInfo[1].title = "Eu preciso de um carro";
        this.identityInfo[1].desc = "Quero ser parceiro 99 e preciso alugar um carro";
      }
    },
    initData() {
      if (this._area.value) {
        this.areaId = this._area.value;
        // this.areaName = this._area.text;
        if (this._area.value === OTHER_CITY_ID) {
          this.title = "";
          this.showTypeInfo = false;
        }
      } else {
        // @20220217 巴西角色页下掉经纬度获取
        // this.getLocation();
      }
      this._identity && (this.identity = this._identity);
    },
    handleClick(tag, payload) {
      switch (tag) {
        case "city":
          this.$router.push({ name: "city" });
          break;
        case "identity":
          this.identity = payload;
          this.setState({
            _identity: this.identity
          });
          try {
            Omega.trackEvent("gd_driverRole_btn_ck", "", {
              driver_role: this.identity
            });
          } catch (e) {}
          break;
        case "submit":
          this.handleSubmit();
          return;
          showDialog(this, {
            type: "confirm",
            content: this.$t("typeInfo.submit_tips").replace(
              /{role}/,
              this.identityInfo[this.identity].title
            ),
            icon: "cubeic-alert",
            confirmBtn: {
              text: this.$t("typeInfo.OK")
            },
            cancelBtn: { text: this.$t("typeInfo.Back") },
            onConfirm: this.handleSubmit
          });
        default:
          break;
      }
    },
    handleSubmit() {
      // 不提交信息,暂存在store中，在baseInfo页面中一起提交
      if (!this.isCanSubmit) return;
      try {
        Omega.trackEvent("gd_driverRoleSubmit_btn_ck", "", {
          driver_role: this.identity,
          ibt_crm_uid: this._uuid
        });
        gtm({ 'event': 's5ObIdSelection',
          'Identity': this._identity,
           'error': 'false' })
      } catch (e) {}

      this.$router.push({
        name: `baseInfo${SUPPORT_COUNTRY[this.location_country]}`
      });
    },
    getLocateCity(lng, lat) {
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      if (!up.get("lng")) {
        up.set("lng", lng);
        up.set("lat", lat);
      }
      post(process.env.GETCITY_URL, up)
        .then(data => {
          this.areaId = data.value;
          // this.areaName = data.text;
          this.setState({
            _area: {
              text: data.text,
              value: data.value
            },
            _open_type: data.open_type
          });
        })
        .catch(e => {
          console.log(e);
        });
    },
    getLocation() {
      let up = new URLSearchParams(location.search);
      let lng = up.get("lng");
      let lat = up.get("lat");
      if (lat && lng) {
        this.getLocateCity(lng, lat);
      } else {
        let that = this;
        /**
         *  获取经纬度信息
         *  position_option 获取经纬度信息的配置项
         *  getPositionSuccess 信息获取成功函数
         *  getPositionError 信息获取失败函数
         */
        var position_option = {
          enableHighAccuracy: true, //告诉浏览器是否启用高精度设备
          maximumAge: 30000, //单位毫秒，告诉设备缓存时间，主要用于设备的省电或者节省带宽方面
          timeout: 3000 //超时时间
        };
        navigator.geolocation.getCurrentPosition(
          getPositionSuccess,
          getPositionError,
          position_option
        );
        function getPositionSuccess(position) {
          // that.locationInfo.lng = position.coords.longitude;
          // that.locationInfo.lat = position.coords.latitude;
          that.getLocateCity(
            position.coords.longitude,
            position.coords.latitude
          );
        }
        function getPositionError(e) {
          console.log(e);
        }
      }
    }
  },
  components: {
    MainTitle,
    TypeCard,
    OfflineSite
  }
};
</script>
<style lang="scss" scoped>
.typeInfo {
  .city-area {
    padding: 0.04rem;
    margin-bottom: 0.36rem;
    .choose-city {
      display: flex;
      align-items: center;
      width: 100%;
      height: 0.9rem;
      background: #fff;
      line-height: 0.9rem;
      padding: 0 0.44rem 0 0.32rem;
      box-sizing: border-box;
      position: relative;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      label {
        font-size: 0.4rem;
      }
      .select-txt {
        font-size: 0.28rem;
        color: #999;
      }
      & > i {
        border: 7px solid transparent;
        border-top-color: #000;
        position: absolute;
        top: 50%;
        right: 0.2rem;
        transform: translateY(-25%);
      }
    }
  }
  .typeInfoContent {
    margin-bottom: 0.8rem;
  }
  .otherCityTxt {
    padding: 0 0.32rem;
    margin-bottom: 0.36rem;
    line-height: 1.3;
    font-size: 0.4rem;
  }
  .btn-wraper {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0.43rem 0.31rem;
    input {
      width: 6.84rem;
      height: 1.06rem;
      font-size: 0.4rem;
      color: #999;
      background: #ccc;
      text-align: center;
      border-radius: 0.06rem;
    }
    .active {
      color: #323233;
      background: #ffe600;
    }
  }
}
</style>

